export default __webpack_public_path__ + "static/media/pin.a0e5344a.svg";